// extracted by mini-css-extract-plugin
module.exports = {"search":"Search_search__3Tlld","searchContainer":"Search_searchContainer__Xl-0F","slide":"Search_slide__e6NzR","searchInitial":"Search_searchInitial__CmVvh"};